import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useState, useEffect } from 'react';
import { useTableColumns } from './hooks/useTableColumns';

import "assets/scss/billingPortal/modules/transactionHistory.scss";
import { Datepicker } from 'components/form/Datepicker';
import moment from 'moment';
import { convertArrayToDropdownArrayFormat, getTotalCountFromHeader, isArrayEmpty, isArrayNotEmpty, isNullUndefined } from 'functions';
import useOutletsActions from 'dataflow/billingPortal/actions/useOutlet.actions';
import useFilters from './hooks/useFilters';
import { Dropdown } from 'components/filters/Dropdown';
import { ListBoxModal } from 'components/modals/ListBoxModal';
import FiltersWrapper from 'components/filters/FiltersWrapper';
import { Toaster } from 'components/notification/Toaster';
import { MoreButton, SubmenuTooltip } from 'components';
import ic_export from 'assets/images/ic_export.svg';
import useExportData from './hooks/useExportData';

export default function TransactionHistory() {

    const [isExporting, setIsExporting] = useState();

    const {
        renderDate, setRenderDate,
        comId,
        outletIDs, setOutletIDs,

        isFiltering, onFilterSubmit,
        isResetRequired,
        isOutletListModalVisible, setIsOutletListModalVisible
    } = useFilters();
    const {
        getAllComList_requesting, allComList
    } = useCustomSelector("accountControl");
    const {
        getAllOutletList_requesting, allOutletList,
        getOutletList_requesting, outletSTList, outletSTListHeaders,
        getAllOutletSTList_requesting, allOutletSTList
    } = useCustomSelector("outlet");

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        getOutletSTList, getAllOutletSTList
    } = useOutletsActions();

    const columns = useTableColumns();

    // handle export
    const exportData = useExportData();
    useEffect(() => {
        if (isExporting && !getAllOutletSTList_requesting && isArrayNotEmpty(allOutletSTList)) 
            exportData();
    }, [getAllOutletSTList_requesting]);

    return (
        <DashboardLayout
            headerTitle={"Transaction History"}

            bodyClassName={"transaction-history"}
            body={(
                <GeneralTable
                    className={"transaction-history__table"}
                    columns={columns}
                    data={userPermissions?.Internal_TransactionHist_View? outletSTList: []}

                    getTableData={getOutletSTList}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>

                                    {/* More Actions */}
                                    <SubmenuTooltip
                                        buttonClassName={"top-section__more-actions"}
                                        menuItems={[
                                            {
                                                icon: ic_export,
                                                label: "Export",
                                                isDisabled: isArrayEmpty(outletSTList) || isNullUndefined(outletSTList),
                                                onClick: () => {
                                                    setIsExporting(true);
                                                    getAllOutletSTList(getTotalCountFromHeader(outletSTListHeaders), filterOptions);
                                                },
                                            }
                                        ]}
                                    >
                                        <MoreButton
                                            className={"more-actions__icon-wrapper"}
                                            iconClassName={"icon-wrapper__icon"}
                                        />
                                    </SubmenuTooltip>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section d-flex"}>
                                    <FiltersWrapper
                                        isFiltering={isFiltering}
                                        isDisabled={!(userPermissions?.Internal_TransactionHist_View)}
                                        submitDisabledMsg={"'Com Info: View' permission required"} 
                                        clearDisabledMsg={"'Com Info: View' permission required"}
                                        onSubmit={() => onFilterSubmit(setFilterOptions, filterOptions)}
                                        onClear={() => onFilterSubmit(setFilterOptions, {}, true)}
                                    >
                                        {/* Render Date */}
                                        <Datepicker
                                            className={"bottom-section__render-date"}
                                            inputClassName={"render-date__input"}
                            
                                            label={"Render Date"}
                                            dateFromParent={renderDate}
                                            defaultDate={renderDate}
                                            handleOnChange={setRenderDate}
                                            isResetRequired={isResetRequired}

                                            isConversionRequired_ISO8601
                                        />

                                        {/* Company ID */}
                                        <Dropdown
                                            className={"bottom-section__company-id"}
                                            label={"COM ID"}

                                            selectedValueClassName={"company-id__input"}
                                            isListLoading={getAllComList_requesting}

                                            options={(isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                let comId = obj?.ComId? obj.ComId:"";
                                                let comName = obj?.ComName? obj?.ComName:"";

                                                return {
                                                    label: comId + " - " + comName,
                                                    value: comId
                                                };
                                            }):""}
                                            valueFromParent={comId.current}
                                            selectedValue_default={comId.current}
                                            onChange={(value) => {
                                                comId.current = value;
                                                setOutletIDs([]);
                                            }}
                                            onEnterKeyPressed={() => onFilterSubmit(setFilterOptions, filterOptions)}
                                            isResetRequired={isResetRequired}

                                            isInputDigitOnly isSearchable
                                        />

                                        {/* Outlet */}
                                        <Dropdown
                                            className={"bottom-section__outlet"}
                                            label={"Outlet"}

                                            isUpdatingLabel_fromParent
                                            selectedValueLabel_default={(isArrayNotEmpty(outletIDs))? outletIDs.length + " Outlets":""}
                                            placeholder={"Select Outlet(s)"}

                                            selectedValueClassName={"outlet__input"}
                                            onClick={() => {
                                                if (comId.current)
                                                    setIsOutletListModalVisible(true);
                                                else {
                                                    Toaster({
                                                        type: "info",
                                                        msg: "COM ID filter required"
                                                    })
                                                }
                                            }}

                                            isResetRequired={isResetRequired}
                                        />

                                        {/* Outlet List */}
                                        <ListBoxModal
                                            isModalVisible={isOutletListModalVisible}
                                            updateParentState={setIsOutletListModalVisible}

                                            title={"Outlet"}

                                            header={"List"}

                                            initSelectedIndexes={(isArrayNotEmpty(outletIDs))? outletIDs.map((id) => {
                                                // Find position of the ids in the "allOutletList" list
                                                for (let i = 0; i < allOutletList.length; i++) {
                                                    if (allOutletList[i]?.ID === id) {
                                                        return i;
                                                    }
                                                }
                                            }):[]}
                                            labelList={(isArrayNotEmpty(allOutletList))? allOutletList.map((obj) => {
                                                return obj?.LOCATIONNAME;
                                            }):[]}
                                            list={(isArrayNotEmpty(allOutletList))? allOutletList.map((obj) => {
                                                return obj?.ID;
                                            }):[]}
                                            isListLoading={getAllOutletList_requesting}

                                            actionTxt={"Save"}
                                            handleOnConfirm={(list) => { 
                                                setOutletIDs(list);
                                                setIsOutletListModalVisible(false);
                                            }}
                                        />
                                    </FiltersWrapper>
                                </div>
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={getOutletList_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(outletSTListHeaders)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}
        />
    );
}